import { faker } from '@faker-js/faker'

import { getRatingScale } from './RatingScale'

import { UserServiceOfferRating } from '../../contracts/service-offer'
import { asBuilder } from '../asBuilder'

export const getUserServiceOfferRating = asBuilder((): UserServiceOfferRating => {
  return {
    totalRating: faker.number.float({ min: 1, max: 10, multipleOf: 0.1 }),
    ratingCount: faker.number.int(),
    ratingScales: faker.helpers.multiple(getRatingScale),
  }
})
